import React, { useContext } from 'react';
import classNames from 'classnames';
import { bool } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { AddToCart } from '@thd-olt-component-react/add-to-cart';
import { Image } from '@thd-olt-component-react/core-ui';

import { useAddToCartProps } from '../../hooks/useAddToCartProps';
import { TotalPrice } from './TotalPrice';
import { PackagesMiniContext } from '../PackagesMiniContext';
import './package-price-suite.scss';

const PackagePriceSuite = () => {
  const { channel } = useContext(ExperienceContext);
  const {
    packageModel: {
      isMajorAppliancePackage
    } = {},
    products
  } = useContext(PackagesMiniContext);
  const { cartReqParams, cartOptions, isAddToCartDisabled } = useAddToCartProps();

  const priceSuiteClasses = classNames('package-price-suite', {
    'package-price-suite--space': channel === 'mobile'
  });

  return (
    <div className={priceSuiteClasses}>
      <div className="package-price-suite__price">
        <p className="package-price-suite__message">
          {'Price for Bundle: '}
        </p>
        <TotalPrice products={products} />
      </div>
      {isMajorAppliancePackage && (
        <div className="package-price-suite__delivery">
          <Image
            src="https://assets.thdstatic.com/images/v1/alert-check-green.svg"
            alt="Free Delivery"
          />
          <h3 className="package-price-suite__delivery-text">Free Delivery</h3>
        </div>
      )}
      <AddToCart
        outline
        cartReqParams={cartReqParams}
        cartOptions={cartOptions}
        disabled={isAddToCartDisabled}
      >
        Add Bundle to Cart
      </AddToCart>
    </div>
  );
};

PackagePriceSuite.themeProps = {
  hideFinancingOffer: bool
};

PackagePriceSuite.defaultThemeProps = {
  hideFinancingOffer: false
};

PackagePriceSuite.displayName = 'PackagePriceSuite';

export { PackagePriceSuite };
